import React from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function OuterPost({ outerpost }) {
  return (
    <Card className="mb-3">
      <Link to={`/outPost/${outerpost._id}`}>
        <Card.Img src={outerpost.image} className="masonry-card-img" />
      </Link>
      <Card.Body>
        <Link to={`/outPost/${outerpost._id}`}>
          <Card.Title as="div">
            <strong>{outerpost.title}</strong>
          </Card.Title>
        </Link>
        <Card.Text className="text-muted">by {outerpost.nickname}</Card.Text>
        <Card.Text className="text-muted">
          <i className="fa-regular fa-comment"></i> {outerpost.comment_count || 0}
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default OuterPost